import { useUser } from '../../User/containers/UserDataStore';

const defaultFormat: Intl.DateTimeFormatOptions = {
	year: 'numeric',
	month: 'numeric',
	day: 'numeric',
};

export default function useLocalizeDate(
	dateFormat: Intl.DateTimeFormatOptions = defaultFormat,
): (jsonDate: string) => string | null {
	const user = useUser();

	return (jsonDate: string): string | null => {
		const hasValidDate = jsonDate && jsonDate !== '0001-01-01T00:00:00';
		if (!hasValidDate) {
			return null;
		}
		return new Date(jsonDate).toLocaleDateString(
			getCultureIndicator(user),
			dateFormat,
		);
	};
}

function getCultureIndicator(userDataStore: any) {
	const country =
		userDataStore.state.organization &&
		userDataStore.state.organization.address
			? userDataStore.state.organization.address.country
			: 'US';
	if (country === 'UK' || country === 'GB') {
		return 'en-GB';
	}
	return 'en-US';
}
